import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/repo/src/app/docs/docs.css");
;
import(/* webpackMode: "eager" */ "/root/repo/src/app/landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["LandingShell"] */ "/root/repo/src/components/landing/shell.tsx");
